module.exports = __webpack_public_path__ + "static/media/match-system.10589d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/productService/images/match-system.png
// module id = 156
// module chunks = 0